(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.PlacementController = (function(superClass) {
    extend(PlacementController, superClass);

    function PlacementController(scope, transitions, state, location, timeout) {
      var ref;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.location = location;
      this.timeout = timeout;
      this.showErrorPopup = bind(this.showErrorPopup, this);
      this.transitionTo = bind(this.transitionTo, this);
      this.draw = bind(this.draw, this);
      this.loadMarker = bind(this.loadMarker, this);
      $('.leaflet-control-buttongrid').show();
      this.scope.repo = this.location;
      this.scope.tool_active = true;
      this.scope.transitionTo = this.transitionTo;
      if (this.location["new"].id) {
        this.location.marker_placed = true;
        this.loadMarker();
      }
      if (this.location["new"] == null) {
        this.state.go('^');
        return;
      }
      if (!((ref = this.location.drawControl) != null ? ref._map : void 0)) {
        App.map.addControl(this.location.drawControl);
      }
      $('.leaflet-control-container').show();
      this.location.drawControl.select();
      App.map.on('draw:created', this.draw);
      this.location.drawControl.on('mfmarker:tool_selected', (function(_this) {
        return function(e) {
          _this.scope.tool_active = true;
          return _this.scope.$apply();
        };
      })(this));
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          var ref1;
          if ($transition.to().name !== 'grower.buyerlocation.locate' && $transition.to().name !== 'grower.buyerlocation.identify') {
            if (_this.location.feature_group != null) {
              App.map.removeLayer(_this.location.feature_group);
            }
            if ((ref1 = _this.location.drawControl) != null ? ref1._map : void 0) {
              App.map.removeControl(_this.location.drawControl);
            }
          }
          _this.location.drawControl.deselect();
          return App.map.off('draw:created', _this.draw);
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.transitionStart();
        };
      })(this));
    }

    PlacementController.prototype.loadMarker = function() {
      var marker;
      if (Object.keys(this.location.feature_group._layers).length > 0) {
        return;
      }
      marker = L.marker([this.location["new"].latitude, this.location["new"].longitude], {
        icon: this.location.icon
      });
      this.location.feature_group.addLayer(marker);
      return App.map.fitBounds(this.location.feature_group.getBounds());
    };

    PlacementController.prototype.draw = function(e) {
      var lat, long;
      lat = e.layer._latlng.lat;
      long = e.layer._latlng.lng;
      return this.location.checkPlacement(lat, long).then((function(_this) {
        return function(response) {
          if (response.data.status.type === 'error') {
            _this.showErrorPopup(response.data.status.msg, lat, long);
            _this.timeout(function() {
              return _this.location.drawControl.select();
            }, 500);
            return;
          }
          if (_this.location.marker_placed) {
            _this.location.feature_group.eachLayer(function(layer) {
              return _this.location.feature_group.removeLayer(layer);
            });
          } else {
            _this.location.marker_placed = true;
          }
          e.layer.options.icon = _this.location.icon;
          _this.location.feature_group.addLayer(e.layer);
          _this.location["new"].latitude = lat;
          _this.location["new"].longitude = long;
          _this.location["new"].zip = response.data.data.zip;
          _this.location["new"].admin_area_2_id = response.data.data.admin_area_2_id;
          return _this.scope.tool_active = false;
        };
      })(this));
    };

    PlacementController.prototype.transitionTo = function(state_name) {
      return this.state.go(state_name);
    };

    PlacementController.prototype.showErrorPopup = function(error_msg, lat, long) {
      L.popup({
        closeButton: false,
        className: 'storagePopup'
      }).setLatLng(L.latLng(lat, long)).setContent(error_msg).openOn(App.map);
      return this.timeout((function(_this) {
        return function() {
          return App.map.closePopup();
        };
      })(this), 3000);
    };

    return PlacementController;

  })(Controller);

}).call(this);
